import { render, staticRenderFns } from "./RaceTableFooterHeadings.vue?vue&type=template&id=91765112"
import script from "./RaceTableFooterHeadings.vue?vue&type=script&lang=js"
export * from "./RaceTableFooterHeadings.vue?vue&type=script&lang=js"
import style0 from "./RaceTableFooterHeadings.vue?vue&type=style&index=0&id=91765112&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports